import { Lot, Model, Amenity, POI, ExteriorPalette } from '../types'

// Lots
export const lots: Lot[] = [
  {
    id: 1,
    status: 'sold',
    price: 185000,
    sqft: 8500,
    coordinates: { x: 30, y: 62 },
    polygon: '25,60 35,58 37,66 27,68',
    block: 'Block 1',
    facing: 'N',
  },
  {
    id: 2,
    status: 'available',
    price: 200000,
    sqft: 9200,
    coordinates: { x: 48, y: 68 },
    polygon: '43,66 53,64 55,72 45,74',
    block: 'Block 1',
    facing: 'E',
  },
  {
    id: 3,
    status: 'available',
    price: 215000,
    sqft: 10500,
    coordinates: { x: 68, y: 72 },
    polygon: '63,70 73,68 75,76 65,78',
    block: 'Block 2',
    facing: 'S',
  },
]

// Models
export const models: Model[] = [
  {
    id: 'm1',
    name: 'The Madison',
    price: 450000,
    sqft: 2400,
    beds: 4,
    baths: 2.5,
    description: 'Open concept living with a spacious master suite.',
    compatibleLots: [2, 3],
    elevations: [
      {
        id: 'e1a',
        letter: 'A',
        name: 'Traditional',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=600&q=80',
        floorplans: [
          'https://images.unsplash.com/photo-1503174971373-b1f69850bded?auto=format&fit=crop&w=800&q=80',
          'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=800&q=80',
        ],
      },
      {
        id: 'e1b',
        letter: 'B',
        name: 'Modern Farmhouse',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=600&q=80',
        floorplans: [
          'https://images.unsplash.com/photo-1503174971373-b1f69850bded?auto=format&fit=crop&w=800&q=80',
        ],
      },
      {
        id: 'e1c',
        letter: 'C',
        name: 'Craftsman',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=600&q=80',
      },
    ],
  },
  {
    id: 'm2',
    name: 'The Ashford',
    price: 525000,
    sqft: 2800,
    beds: 5,
    baths: 3,
    description: 'Luxury estate home with double-height foyer.',
    compatibleLots: [2, 3],
    elevations: [
      {
        id: 'e2a',
        letter: 'A',
        name: 'European',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=600&q=80',
        floorplans: [
          'https://images.unsplash.com/photo-1503174971373-b1f69850bded?auto=format&fit=crop&w=800&q=80',
        ],
      },
      {
        id: 'e2b',
        letter: 'B',
        name: 'Tudor',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=600&q=80',
      },
      {
        id: 'e2c',
        letter: 'C',
        name: 'Contemporary',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=600&q=80',
        floorplans: [
          'https://images.unsplash.com/photo-1503174971373-b1f69850bded?auto=format&fit=crop&w=800&q=80',
          'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=800&q=80',
        ],
      },
    ],
  },
  {
    id: 'm3',
    name: 'The Bristol',
    price: 395000,
    sqft: 1950,
    beds: 3,
    baths: 2,
    description: 'Perfect starter home with efficient layout.',
    compatibleLots: [2],
    elevations: [
      {
        id: 'e3a',
        letter: 'A',
        name: 'Cottage',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=600&q=80',
        floorplans: [
          'https://images.unsplash.com/photo-1503174971373-b1f69850bded?auto=format&fit=crop&w=800&q=80',
        ],
      },
      {
        id: 'e3b',
        letter: 'B',
        name: 'Bungalow',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1600585154084-4e5fe7c39198?auto=format&fit=crop&w=600&q=80',
      },
    ],
  },
  {
    id: 'm4',
    name: 'The Cambridge',
    price: 480000,
    sqft: 2600,
    beds: 4,
    baths: 3,
    description: 'Spacious family home with bonus room.',
    compatibleLots: [2, 3],
    elevations: [
      {
        id: 'e4a',
        letter: 'A',
        name: 'Colonial',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?auto=format&fit=crop&w=600&q=80',
      },
      {
        id: 'e4b',
        letter: 'B',
        name: 'Georgian',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?auto=format&fit=crop&w=600&q=80',
        floorplans: [
          'https://images.unsplash.com/photo-1503174971373-b1f69850bded?auto=format&fit=crop&w=800&q=80',
        ],
      },
    ],
  },
  {
    id: 'm5',
    name: 'The Dover',
    price: 410000,
    sqft: 2100,
    beds: 3,
    baths: 2.5,
    description: 'Modern living with smart home features.',
    compatibleLots: [2],
    elevations: [
      {
        id: 'e5a',
        letter: 'A',
        name: 'Modern',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1600607687644-c7171b42498f?auto=format&fit=crop&w=600&q=80',
        floorplans: [
          'https://images.unsplash.com/photo-1503174971373-b1f69850bded?auto=format&fit=crop&w=800&q=80',
          'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=800&q=80',
        ],
      },
      {
        id: 'e5b',
        letter: 'B',
        name: 'Industrial',
        thumbnailUrl:
          'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=600&q=80',
      },
    ],
  },
]

// Amenities with categories - MORE ITEMS
export const amenities: Amenity[] = [
  {
    id: 'a1',
    name: 'Community Pool',
    category: 'Recreation',
    description:
      'Resort-style infinity pool with lap lanes and kids splash area.',
    images: [
      'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 45, y: 25 },
  },
  {
    id: 'a2',
    name: 'Clubhouse',
    category: 'Social',
    description:
      'Modern gathering space with lounge, kitchen, and event rooms.',
    images: [
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 55, y: 30 },
  },
  {
    id: 'a3',
    name: 'Fitness Center',
    category: 'Wellness',
    description: 'State-of-the-art gym with cardio, weights, and yoga studio.',
    images: [
      'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 65, y: 35 },
  },
  {
    id: 'a4',
    name: 'Playground',
    category: 'Recreation',
    description: 'Safe and fun play structures for children of all ages.',
    images: [
      'https://images.unsplash.com/photo-1551829142-d9b8cf2c9232?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 50, y: 45 },
  },
  {
    id: 'a5',
    name: 'Tennis Courts',
    category: 'Recreation',
    description: 'Two professional tennis courts with night lighting.',
    images: [
      'https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 70, y: 50 },
  },
  {
    id: 'a6',
    name: 'Spa & Sauna',
    category: 'Wellness',
    description: 'Relaxation area with hot tub, sauna, and massage rooms.',
    images: [
      'https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 60, y: 55 },
  },
  {
    id: 'a7',
    name: 'Dog Park',
    category: 'Recreation',
    description: 'Fenced area for dogs to play and socialize.',
    images: [
      'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 75, y: 40 },
  },
  {
    id: 'a8',
    name: 'Community Garden',
    category: 'Social',
    description:
      'Shared garden plots for residents to grow vegetables and flowers.',
    images: [
      'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 80, y: 60 },
  },
]

// Surrounding POIs with multiple images - MORE ITEMS
export const pois: POI[] = [
  {
    id: 'p1',
    name: 'Lake View Park',
    category: 'Nature',
    description: 'Scenic park with walking trails and lake access.',
    images: [
      'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 45, y: 20 },
    websiteUrl: 'https://example.com',
  },
  {
    id: 'p2',
    name: 'Hiking Trail Head',
    category: 'Nature',
    description: 'Start of the 5-mile scenic loop trail.',
    images: [
      'https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 85, y: 25 },
  },
  {
    id: 'p3',
    name: 'The Bistro',
    category: 'Dining',
    description: 'Farm-to-table dining with outdoor patio.',
    images: [
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 55, y: 65 },
  },
  {
    id: 'p4',
    name: 'Coffee Shop',
    category: 'Dining',
    description: 'Artisanal coffee and fresh pastries.',
    images: [
      'https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 65, y: 70 },
  },
  {
    id: 'p5',
    name: 'Yoga Studio',
    category: 'Fitness',
    description: 'Peaceful studio offering daily classes.',
    images: [
      'https://images.unsplash.com/photo-1588286840104-8957b019727f?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 75, y: 65 },
  },
  {
    id: 'p6',
    name: 'Riverside Trail',
    category: 'Nature',
    description: '3-mile paved trail along the river.',
    images: [
      'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 50, y: 75 },
  },
  {
    id: 'p7',
    name: 'Italian Restaurant',
    category: 'Dining',
    description: 'Authentic Italian cuisine with wine bar.',
    images: [
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 70, y: 75 },
  },
  {
    id: 'p8',
    name: 'CrossFit Gym',
    category: 'Fitness',
    description: 'High-intensity functional fitness training.',
    images: [
      'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 80, y: 70 },
  },
  {
    id: 'p9',
    name: 'Botanical Garden',
    category: 'Nature',
    description: 'Beautiful gardens with seasonal displays.',
    images: [
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 60, y: 80 },
  },
  {
    id: 'p10',
    name: 'Sushi Bar',
    category: 'Dining',
    description: 'Fresh sushi and Japanese cuisine.',
    images: [
      'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?auto=format&fit=crop&w=600&q=80',
    ],
    coordinates: { x: 75, y: 80 },
  },
]

// Exterior Palettes - with both images and color swatches
export const exteriorPalettes: ExteriorPalette[] = [
  {
    id: 'pal1',
    name: 'Modern Gray',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1560185007-cde436f6a4d0?auto=format&fit=crop&w=100&q=80',
    colors: ['#6B7280', '#9CA3AF', '#E5E7EB', '#1F2937'],
  },
  {
    id: 'pal2',
    name: 'Classic White',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1585128792020-803d29415281?auto=format&fit=crop&w=100&q=80',
    colors: ['#FFFFFF', '#F3F4F6', '#D1D5DB', '#374151'],
  },
  {
    id: 'pal3',
    name: 'Warm Beige',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=100&q=80',
    colors: ['#D4C5B9', '#E8DDD3', '#F5F0EB', '#8B7355'],
  },
  {
    id: 'pal4',
    name: 'Coastal Blue',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1574169208507-84376144848b?auto=format&fit=crop&w=100&q=80',
    colors: ['#60A5FA', '#93C5FD', '#DBEAFE', '#1E40AF'],
  },
  {
    id: 'pal5',
    name: 'Charcoal',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=100&q=80',
    colors: ['#374151', '#4B5563', '#6B7280', '#111827'],
  },
  {
    id: 'pal6',
    name: 'Sage Green',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=100&q=80',
    colors: ['#86A789', '#B2C9AD', '#D5E1D0', '#5F7161'],
  },
]
